import React from 'react';
import { LexicalRichTextEditor } from './richText/LexicalRichTextEditor';
import { QuillRichTextEditor } from './QuillRichTextEditor';
import type { RichTextEditorProps } from './richText/types';

export type { RichTextEditorProps, RichTextEditorShellVariant, RichTextEngine } from './richText/types';

/**
 * Shared rich-text field. Defaults to Lexical (`@lexical/react`); pass `engine="quill"` for ReactQuill.
 * Value is HTML string in / out for API + draft compatibility.
 */
export const RichTextEditor: React.FC<RichTextEditorProps> = ({ engine = 'lexical', ...props }) => {
    if (engine === 'quill') {
        return <QuillRichTextEditor {...props} />;
    }
    return <LexicalRichTextEditor {...props} />;
};
